import { CANCELED_STATUS } from "constants";
import { del, get, getPublic, post, postPublic, put } from "./api-helper";

const paymentsAPI = {
  newOrderCheckout: ({ lines, intentId }) =>
    post("/payments/checkout", lines, intentId ? { params: { intentId } } : {}),
  orderCheckout: ({ lines, orderId }) => post(`/payments/checkout/${orderId}`, lines),
};

const newOrderAPI = {
  createOrder: ({ order, intentId }) => postPublic(`/quote`, order, intentId ? { params: { intentId } } : {}),
  calculateOrderPrice: ({ order, userId }) => post(`/pricing/calculatePrice/${userId}`, order),
  paseCsvQuote: (form) => put("/quote/csv", form, { headers: { "Content-Type": "multipart/form-data" } }),
};

const ordersAPI = {
  orders: ({ page, filters }) => get(`/orders/list/all`, { params: { page, ...filters } }),
  riderPosition: (id) => put(`/orders/${id}/location`),
  cancelOrder: (id) => put(`/orders/${id}/status`, { status: CANCELED_STATUS }),
  cancelOrderBatch: (ids) => post(`/orders/bulk/status`, { ids, status: CANCELED_STATUS }),
  downloadOrderReport: ({ userId, filters }) => get(`/orders/${userId}/download`, { params: { ...filters } }),
};

const addressAPI = {
  addresses: () => get(`/library/addresses`),
  createAddress: (address) => post(`/library/address`, address),
  removeAddress: (id) => del(`/library/address/${id}`),
  updateAddress: (address) => put(`/library/address/${address.id}`, address),
};
const savedOrdersAPI = {
  orders: () => get(`/library/orders`),
  saveOrder: (order) => post(`/library/order/${order.id}`, order),
  removeOrder: (id) => del(`/library/order/${id}`, id),
  updateOrder: (order) => put(`/library/order/${order.id}`, order),
};
const libraryAPI = { ...addressAPI, ...savedOrdersAPI };

const contactAPI = {
  register: (partner) => postPublic(`/partner/new`, partner),
  contact: (id) => get(`/contacts/${id}`),
  updateContact: ({ contact, userId }) => put(`/contacts/${userId}`, contact),
  changeLocale: ({ id, locale }) => put(`/contacts/locale/${id}`, { locale }),
  reacceptTerms: (id) => put(`/contacts/${id}/terms`),
};

const localizationAPI = {
  getLocalizations: () => getPublic("/localizations"),
};

const invoicesAPI = {
  invoices: ({ page, filters }) => get(`/invoices`, { params: { page, ...filters } }),
  getDownloadLink: (id) => post(`/invoices/download/${id}`),
};

const PartnerApi = {
  ...newOrderAPI,
  ...ordersAPI,
  library: { ...libraryAPI },
  ...contactAPI,
  ...localizationAPI,
  ...invoicesAPI,
  ...paymentsAPI,
};

export default PartnerApi;
